<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close" @open="open">
            <div class="content">
                <div class="header">
                    <span> {{ $t("person.PersonalCenter") }} </span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation" class="icon-base_root-F1flk icon-base_m-F1flk" data-icon="close" @click="close">
                        <path fill="currentColor"
                            d="M3.364 3.364a.9.9 0 0 1 1.272 0L8 6.727l3.364-3.363a.9.9 0 0 1 1.272 1.272L9.274 8l3.364 3.364a.9.9 0 1 1-1.273 1.272L8 9.274l-3.364 3.364a.9.9 0 1 1-1.272-1.273L6.727 8 3.364 4.636a.9.9 0 0 1 0-1.272"
                            clip-rule="evenodd"></path>
                    </svg>
                </div>
                <person ref="person"></person>
            </div>
        </van-popup>
    </div>
</template>

<script>
import person from '@/views/person/index.vue'
export default {
    name: 'my',
    data() {
        return {
            isFirstReload: true
        }
    },
    components: {
        person
    },
    computed: {
        show: {
            get() {
                return this.$store.getters.isShowMyPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() { },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
        },
        open() {
            this.$nextTick(() => {
                this.$refs.person.init()
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        .content {
            min-height: 500px;
            width: 470px;
            max-height: calc(100% - 48px);
            max-width: calc(100% - 48px);
            margin: 24px;
            pointer-events: auto;
            contain: layout;
            outline: none;
            background:
                radial-gradient(circle at 18% 0, rgba($border-active-color, .18) 0, rgba($border-active-color, 0) 34%),
                linear-gradient(180deg, rgba($font-title-color, .08) 0%, rgba($font-title-color, 0) .18rem),
                $bg-component-blue-deep-gradient-color;
            box-shadow: 0 .18rem .44rem rgba($bg-shell-color, 0.24), inset 0 1px 0 rgba($font-title-color, 0.12);
            border-radius: 20px !important;
            display: flex;
            flex-direction: column;
            // overflow: auto;

            .header{
                font-size: 20px;
                margin: 20px 20px 10px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: $font-component-cool-color;
                font-size: .36rem;
                text-shadow: 0 1px 2px rgba(6, 26, 58, 0.32);

                svg{
                    width: .42rem;
                    height: .42rem;
                    color: $font-component-cool-color;
                    cursor: pointer;
                }
            }

            ::v-deep .pages{
                background: transparent;
                flex: 1;
                overflow: auto;
            }

            ::v-deep .pages::-webkit-scrollbar {
                width: 8px;
            }

            ::v-deep .pages::-webkit-scrollbar-thumb {
                background: $bg-component-highlight-color;
                border-radius: 999px;
            }

            ::v-deep .pages::-webkit-scrollbar-track {
                background: rgba($font-title-color, 0.08);
                border-radius: 999px;
            }

            ::v-deep .pages .func_btns > div {
                background:
                    linear-gradient(180deg, rgba($font-title-color, .18) 0%, rgba($font-title-color, .06) 24%, rgba($font-title-color, 0) 25%),
                    $bg-component-button-soft-color !important;
                color: $font-component-cool-color !important;
                border: 1px solid rgba($border-active-color, .22) !important;
                box-shadow: $shadow-component-button-color !important;
            }

            ::v-deep .pages .func_btns > div:first-child {
                background:
                    linear-gradient(180deg, rgba($font-title-color, .24) 0%, rgba($font-title-color, .08) 26%, rgba($font-title-color, 0) 27%),
                    $bg-component-highlight-color !important;
                color: $font-color !important;
                border-color: rgba($border-active-color, .42) !important;
                box-shadow: inset 0 1px 0 rgba($font-title-color, .3), 0 .08rem .18rem rgba($bg-shell-color, .18) !important;
            }

            ::v-deep .pages .func_btns > div:last-child {
                background:
                    linear-gradient(180deg, rgba($font-title-color, .12) 0%, rgba($font-title-color, .04) 24%, rgba($font-title-color, 0) 25%),
                    $bg-component-pink-button-color !important;
                color: $font-component-cool-color !important;
                border: 1px solid rgba($border-active-color, .26) !important;
                box-shadow: inset 0 1px 0 rgba($font-title-color, .16), 0 .05rem .12rem rgba($bg-shell-color, .14) !important;
            }
        }
    }
}
</style>
